import PropTypes from "prop-types";
import { handleDynamicImportError } from "@lululemon/ecom-site-utils/src/logger/utils";
import dynamic from "next/dynamic";
import usePreventRageClick from "../../hooks/use-prevent-rage-click";
import { useWebStrings } from "@lululemon/ecom-contentful";
import { removeItemModalKeys } from "../../utils/contentful-keys";

const DynamicModal = dynamic(
  () =>
    import("./remove-item-modal-loader").catch(() =>
      handleDynamicImportError("DynamicModal", "RemoveItemModal")
    ),
  {
    ssr: false
  }
);

const RemoveItemModal = ({
  showMultiListConfirmation,
  modalOpen,
  closeModal,
  removeItem,
  dataLuluAttributes,
  title,
  myBagRemoveModalTrackId
}) => {
  const removeItemWithRagePreventedHandler = usePreventRageClick(removeItem);
  const microcopy = useWebStrings(removeItemModalKeys);

  if (!modalOpen) {
    return undefined;
  }

  const {
    "mybag.common.oos-modal-close-label": closeButtonLabel,
    "mybag.product.remove-confirmation-header": defaultTitle,
    "mybag.product.remove-confirm": removeItemText,
    "mybag.product.remove-cancel": cancelText,
    "mybag.oneListSection.multiListItemRemovalConfirmationModal.message":
      multiListConfirmationMsg
  } = microcopy || {};

  const multiListConfirmation = showMultiListConfirmation
    ? multiListConfirmationMsg
    : "";

  const primaryCta = {
    children: removeItemText,
    variant: "filledImpact",
    onClick: removeItemWithRagePreventedHandler,
    "data-lulu-track": myBagRemoveModalTrackId,
    ...dataLuluAttributes
  };

  const secondaryCta = {
    children: cancelText,
    onClick: closeModal,
    "data-lulu-track": "my-bag-product-remove-modal-false",
    ...dataLuluAttributes
  };

  const cancelProps = {
    "data-lulu-track": "my-bag-product-remove-modal-cancel",
    ...dataLuluAttributes
  };

  return (
    <DynamicModal
      visible={modalOpen}
      messages={{ close: closeButtonLabel }}
      onRequestClose={closeModal}
      title={title || defaultTitle}
      titleId="remove-item-modal"
      primaryCta={primaryCta}
      secondaryCta={secondaryCta}
      cancelProps={cancelProps}
      classes={{
        modalContent: "OneLinkTx"
      }}
    >
      {multiListConfirmation}
    </DynamicModal>
  );
};

RemoveItemModal.propTypes = {
  showMultiListConfirmation: PropTypes.bool,
  modalOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  removeItem: PropTypes.func,
  dataLuluAttributes: PropTypes.shape({
    "data-lulu-attributes": PropTypes.string
  }),
  title: PropTypes.string,
  myBagRemoveModalTrackId: PropTypes.string
};

RemoveItemModal.defaultProps = {
  showMultiListConfirmation: false,
  modalOpen: false,
  closeModal: () => {},
  removeItem: () => {},
  dataLuluAttributes: {},
  title: "",
  myBagRemoveModalTrackId: ""
};

export default RemoveItemModal;
